import type { FlagIcon } from '@constants/countryDetails'

export const Br: FlagIcon = ({ testId, ...rest }) => (
  <svg viewBox='0 0 512 512' data-testid={testId} {...rest}>
    <circle cx='256' cy='256' r='256' fill='#6da544' />
    <path fill='#ffda44' d='M256 100.2L467.5 256 256 411.8 44.5 256z' />
    <circle cx='256' cy='256' r='89' fill='#eee' />
    <path
      fill='#0052b4'
      d='M211.5 250.4a149 149 0 0 0-44.5 6.8A89 89 0 0 0 329 307a150 150 0 0 0-117.5-56.7zm131.9 22.7A89.5 89.5 0 0 0 345 256a89 89 0 0 0-170.8-35.1 183.7 183.7 0 0 1 37.3-3.9c51.7 0 98.5 21.5 131.9 56z'
    />
  </svg>
)
